import "./index.css";

import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import App from "./App.tsx";

const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy.tsx"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions.tsx"));
const AppLink = lazy(() => import("./pages/AppLink.tsx"));
const Main = lazy(() => import("./pages/Main.tsx"));
const VisualNovelMain = lazy(() => import("./pages/VisualNovelMain.tsx"));

function loadPage(page: React.ReactNode) {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-[50dvh] items-center justify-center" role="status">
          Loading…
        </div>
      }
    >
      {page}
    </Suspense>
  );
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: loadPage(<Main />),
      },
      {
        path: "/visual-novels",
        element: loadPage(<VisualNovelMain />),
      },

      {
        path: "/privacy-policy",
        element: loadPage(<PrivacyPolicy />),
      },
      {
        path: "/terms-and-conditions",
        element: loadPage(<TermsAndConditions />),
      },
      {
        path: "/app/*",
        element: loadPage(<AppLink />),
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root") as any);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
